export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    width:40,
    align:'center',
    fixed: 'left',
    type:'checkbox'

  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'lineNo',
    align: 'center',
    width: 160,
    title: '线路编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'lineName',
    align: 'left',
    minWidth: 250,
    title: '线路名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'lineTypeName',
    align: 'center',
    width: 120,
    title: '线路类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'v_useDayType',
    align: 'center',
    width: 120,
    title: '日期类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'carrierName',
    align: 'left',
    minWidth: 200,
    title: '承运商',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'lineDesc',
    align: 'left',
    minWidth: 300,
    title: '线路说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'lineStatusName',
    align: 'center',
    width: 100,
    title: '有效状态',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
]
